import { FC, useEffect } from 'react';
import { XMarkIcon as CloseIcon } from '@heroicons/react/24/solid';
import ReactModal, { Props as ReactModalProps } from 'react-modal';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop } from 'helpers/utils/screensizes';

export interface Props extends ReactModalProps {
  closeButton?: boolean;
  preventScroll?: boolean;
}

const Modal: FC<Props> = ({ children, style, preventScroll, closeButton, className = '', ...props }) => {
  const [isDesktopSize] = useMediaQuery(desktop);

  const modalStyle: ReactModalProps['style'] = {
    overlay: {
      zIndex: 51,
      backgroundColor: 'rgba(127, 127, 127, .3)',
      ...style?.overlay,
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      maxWidth: isDesktopSize ? 800 : '85%',
      position: 'relative',
      padding: 0,
      outline: 'none',
      ...style?.content,
    },
  };

  useEffect(() => {
    if (props.isOpen) {
      document.body.style.overflowY = 'hidden';
      document.body.style.overflowX = 'hidden';
      document.body.classList.add('ReactModal__Body--open');
    } else {
      document.body.style.overflowY = '';
      document.body.style.overflowX = '';
      document.body.classList.remove('ReactModal__Body--open');
    }

    return () => {
      document.body.style.overflowY = '';
      document.body.style.overflowX = '';
      document.body.classList.remove('ReactModal__Body--open');
    };
  }, [props.isOpen]);

  return (
    <ReactModal
      {...props}
      ariaHideApp={false}
      style={modalStyle}
      preventScroll={preventScroll}
      className={`${className} relative`}
    >
      {closeButton && (
        <CloseIcon
          className="absolute right-20 top-20 h-24 w-24 cursor-pointer text-secondary-black"
          onClick={(event) => {
            props.onRequestClose && props.onRequestClose(event);
          }}
        />
      )}
      {children}
    </ReactModal>
  );
};

export default Modal;
